module.exports = __webpack_public_path__ + "static/media/bar_chart.eaae8139.svg";